module.exports = __webpack_public_path__ + "static/img/zhuanli07.218ce35.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/zhuanli07.png
// module id = aXFo
// module chunks = 1